export const DELETE_PATIENT = 'Delete patient'
export const UPDATE_PATIENT = 'Update patient'
export const SET_PATIENTS = 'Set patients'
export const SET_PATIENTS_COUNT = 'Set patients count'
export const SET_PATIENT_DATA = 'Set current patient'
export const ADD_PATIENT_DATA = 'Add to current patient'
export const SET_MEDICATION_REQUESTS = 'Set medication'
export const UPDATE_MEDICATION_REQUEST = 'Update medication request'
export const UPDATE_SERVICE_REQUEST = 'Update service request'
export const SET_SERVICE_REQUESTS = 'Set service requests'
export const SET_DIAGNOSTIC_REPORTS = 'Set diagnostic reports'
export const SET_OBSERVATIONS = 'Set observations'
export const UPDATE_OBSERVATION = 'Update observation'
export const DELETE_OBSERVATION = 'Delete observation'
export const SET_PATIENT_DIAGNOSIS = 'Set patient diagnoses'
export const SET_PATIENT_NOTES = 'Set patient notes'
export const DELETE_SERVICE_REQUEST='DELETE_SERVICE_REQUEST'
export const DELETE_MEDICATION_REQUEST='DELETE_MEDICATION_REQUEST'
export const UPDATE_REFERRAL= 'Update referral'
export const SET_REFERRALS= 'Set referrals'
export const DELETE_REFERRAL= 'Delete referral'
export const SET_PATIENTS_META= 'Set patients meta'
export const SET_CARE_PLANS= 'Set patients care plans'
